import React, { useMemo, useState, useEffect } from 'react';
import '../styles/Reports.css';
import HeaderReport from "../components/HeaderReport.js";
import FooterReport from "../components/FooterReport.js";
import { getCaracteristicas } from '../services/caracteristicasService';
import { getTiposSocias, getSocias, getTratamientosPorSocia, getSociasPorProvincia, getSociasPorCanton, getIncidenciasUbicacion, getSociasAfiliadasIESS, getTallaPorSocia, getEdadDeteccion } from '../services/reportesService.js';
import mentorService from '../services/mentorService';
import requisitosService from '../services/requisitosService';
import sociasRequisitosService from '../services/sociasRequisitosService';
import sociasCaracteristicasService from '../services/sociasCaracteristicasService';
import inventoryService from '../services/inventoryService';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

// Registrar componentes de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const handlePrint = () => {
  const printContents = document.querySelector(".report-preview-panel").innerHTML;

  // Recopilar todos los estilos de la página
  const styles = Array.from(document.styleSheets)
    .map(styleSheet => {
      try {
        return Array.from(styleSheet.cssRules)
          .map(rule => rule.cssText)
          .join('\n');
      } catch (e) {
        return '';
      }
    })
    .join('\n');

  // Crear un iframe temporal para impresión
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(`
    <html>
      <head>
        <title>Imprimir Reporte</title>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
        <style>
          ${styles}
          body { margin: 0; padding: 0; background: #fff; }
          img { max-width: 100%; }
          table { page-break-inside: auto; }
          tr { page-break-inside: avoid; page-break-after: auto; }
          thead { display: table-header-group; }
          tfoot { display: table-footer-group; }
        </style>
      </head>
      <body>${printContents}</body>
    </html>
  `);
  doc.close();

  // Imprimir desde el iframe
  iframe.contentWindow.focus();
  iframe.contentWindow.print();

  // Remover el iframe después de imprimir
  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 1000);
};

const handlePDF = async () => {
  try {
    const reportElement = document.querySelector(".report-preview-panel");
    const canvas = await html2canvas(reportElement, {
      scale: 2,
      useCORS: true,
      logging: false,
      allowTaint: true,
      backgroundColor: '#ffffff',
      onclone: (clonedDoc) => {
        Array.from(clonedDoc.getElementsByTagName('img')).forEach(img => {
          img.style.maxWidth = '100%';
        });
      }
    });
    
    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      compress: true
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margins = 10;
    const imgWidth = pdfWidth - (margins * 2);
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
    let heightLeft = imgHeight;
    let position = margins;
    const pageHeight = pdfHeight - (margins * 2);

    pdf.addImage(imgData, "JPEG", margins, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight + margins;
      pdf.addPage();
      pdf.addImage(imgData, "JPEG", margins, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    const reportTitle = document.querySelector(".report-preview-panel h2")?.textContent || "reporte";
    pdf.save(`FEPAST_${reportTitle.toLowerCase().replace(/\s+/g, '_')}.pdf`);
  } catch (error) {
    console.error('Error al generar PDF:', error);
    alert('Hubo un error al generar el PDF. Por favor, inténtelo de nuevo.');
  }
};

const handleExcel = () => {
  try {
    const reportTitle = document.querySelector(".report-preview-panel h2")?.textContent || "Reporte";
    const table = document.querySelector(".report-preview-panel table");
    
    if (!table) {
      alert("No hay tabla para exportar");
      return;
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();
    
    // Get the table data
    const ws = XLSX.utils.table_to_sheet(table, {
      raw: true,
      display: false,
      dateNF: 'dd/mm/yyyy'
    });

    // Adjust column widths
    const columnWidths = [];
    const range = XLSX.utils.decode_range(ws['!ref']);
    
    // Calculate column widths based on content
    for (let C = range.s.c; C <= range.e.c; C++) {
      let maxLength = 0;
      
      for (let R = range.s.r; R <= range.e.r; R++) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = ws[cellAddress];
        
        if (cell && cell.v) {
          const length = String(cell.v).length;
          maxLength = Math.max(maxLength, length);
        }
      }
      
      columnWidths[C] = maxLength + 2; // Add padding
    }

    // Apply column widths
    ws['!cols'] = columnWidths.map(width => ({ width }));

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Datos");

    // Generate Excel file
    const wbout = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true
    });

    // Save the file
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }), 
      `FEPAST_${reportTitle.toLowerCase().replace(/\s+/g, '_')}.xlsx`
    );
  } catch (error) {
    console.error('Error al generar Excel:', error);
    alert('Hubo un error al generar el archivo Excel. Por favor, inténtelo de nuevo.');
  }
};

const handleExcelWithCharts = async (getR14Data) => {
  try {
    // Capturar contenedores de gráficos específicos del r14
    const chartPais = document.getElementById('chart-edad-pais');
    const chartRangos = document.getElementById('chart-rangos-global');

    if (!chartPais && !chartRangos) {
      alert('No hay gráficos visibles para exportar.');
      return;
    }

    const capture = async (el) => {
      if (!el) return null;
      const canvas = await html2canvas(el, { scale: 2, backgroundColor: '#ffffff' });
      return canvas.toDataURL('image/png');
    };

    const imgPais = await capture(chartPais);
    const imgRangos = await capture(chartRangos);

    const wb = new ExcelJS.Workbook();
    wb.creator = 'FEPAST';
    wb.created = new Date();

    // Hoja de gráficos
    const wsCharts = wb.addWorksheet('Gráficos');

    const addImageToSheet = (imageDataUrl, topRow) => {
      if (!imageDataUrl) return;
      const imageId = wb.addImage({ base64: imageDataUrl, extension: 'png' });
      // Anclar imagen (aprox. tamaño)
      wsCharts.addImage(imageId, {
        tl: { col: 0.2, row: topRow },
        ext: { width: 900, height: 360 }
      });
    };

    addImageToSheet(imgPais, 0);
    addImageToSheet(imgRangos, 22);

    // Hoja de datos agregados (r14)
    const wsData = wb.addWorksheet('Datos');
    const { rows, rangos } = getR14Data ? getR14Data() : { rows: [], rangos: [] };
    wsData.addRow(['País', 'Cantidad', 'Edad Promedio', 'Mín', 'Mediana', 'Máx']);
    rows.forEach(r => {
      wsData.addRow([r.pais, r.count, r.avg, r.min, r.median, r.max]);
    });
    wsData.addRow([]);
    wsData.addRow(['Rango', 'Cantidad']);
    rangos.forEach(rr => wsData.addRow([rr.label, rr.value]));

    // Ajuste de ancho
    wsData.columns = [
      { width: 24 }, { width: 12 }, { width: 16 }, { width: 10 }, { width: 12 }, { width: 10 }
    ];

    // Hoja con la tabla visible en la previsualización (si existe)
    const previewTable = document.querySelector('.report-preview-panel table');
    if (previewTable) {
      const wsTable = wb.addWorksheet('Tabla visible');
      const headerCells = Array.from(previewTable.querySelectorAll('thead tr th'));
      if (headerCells.length) {
        wsTable.addRow(headerCells.map(th => th.textContent?.trim() || ''));
      }
      const bodyRows = Array.from(previewTable.querySelectorAll('tbody tr'));
      bodyRows.forEach(tr => {
        const tds = Array.from(tr.querySelectorAll('td'));
        wsTable.addRow(tds.map(td => td.textContent?.trim() || ''));
      });
      // Ajustar ancho de columnas según contenido básico
      const colCount = headerCells.length || (bodyRows[0]?.querySelectorAll('td').length || 0);
      wsTable.columns = new Array(colCount).fill(null).map(() => ({ width: 18 }));
    }

    const buffer = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      `FEPAST_edad_deteccion_con_graficos.xlsx`);
  } catch (error) {
    console.error('Error al generar Excel con gráficos:', error);
    alert('Hubo un error al generar el Excel con gráficos. Por favor, inténtelo de nuevo.');
  }
};

// Exportar a Excel con gráficos para r20 (síndrome por ubicación)
const handleExcelWithChartsR20 = async (getR20Data) => {
  try {
    const chartPais = document.getElementById('chart-r20-por-pais');
    const chartSindromePais = document.getElementById('chart-r20-por-sindrome');

    if (!chartPais && !chartSindromePais) {
      alert('No hay gráficos visibles para exportar.');
      return;
    }

    const capture = async (el) => {
      if (!el) return null;
      const canvas = await html2canvas(el, { scale: 2, backgroundColor: '#ffffff' });
      return canvas.toDataURL('image/png');
    };

    const imgPais = await capture(chartPais);
    const imgSindromePais = await capture(chartSindromePais);

    const wb = new ExcelJS.Workbook();
    wb.creator = 'FEPAST';
    wb.created = new Date();

    // Hoja de gráficos
    const wsCharts = wb.addWorksheet('Gráficos');
    const addImageToSheet = (imageDataUrl, topRow) => {
      if (!imageDataUrl) return;
      const imageId = wb.addImage({ base64: imageDataUrl, extension: 'png' });
      wsCharts.addImage(imageId, { tl: { col: 0.2, row: topRow }, ext: { width: 900, height: 360 } });
    };
    addImageToSheet(imgPais, 0);
    addImageToSheet(imgSindromePais, 22);

    // Hoja de datos tabulares
    const wsData = wb.addWorksheet('Datos');
    const { rowsPais, rowsTs, paisSeleccionado } = getR20Data ? getR20Data() : { rowsPais: [], rowsTs: [], paisSeleccionado: '' };
    // Tabla por país
    wsData.addRow(['País', 'Cantidad']);
    rowsPais.forEach(r => wsData.addRow([r.label, r.value]));
    if (rowsTs && rowsTs.length) {
      wsData.addRow([]);
      wsData.addRow([`Distribución por síndrome en ${paisSeleccionado || ''}`]);
      wsData.addRow(['Síndrome', 'Cantidad']);
      rowsTs.forEach(r => wsData.addRow([r.label, r.value]));
    }
    wsData.columns = [ { width: 36 }, { width: 16 } ];

    const buffer = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      `FEPAST_sindrome_por_ubicacion.xlsx`);
  } catch (error) {
    console.error('Error al generar Excel con gráficos (r20):', error);
    alert('Hubo un error al generar el Excel con gráficos. Por favor, inténtelo de nuevo.');
  }
};

const handleExcelWithChartsR13 = async (getR13Data) => {
  try {
    const chartContainer = document.getElementById('chart-r13-talla');

    if (!chartContainer) {
      alert('No hay gráfico visible para exportar.');
      return;
    }

    // Capturar el gráfico
    const canvas = await html2canvas(chartContainer, { scale: 2, backgroundColor: '#ffffff' });
    const imgChart = canvas.toDataURL('image/png');

    const wb = new ExcelJS.Workbook();
    wb.creator = 'FEPAST';
    wb.created = new Date();

    // Hoja de gráfico
    const wsCharts = wb.addWorksheet('Gráfico');
    const imageId = wb.addImage({ base64: imgChart, extension: 'png' });
    wsCharts.addImage(imageId, {
      tl: { col: 0.2, row: 0 },
      ext: { width: 900, height: 400 }
    });

    // Hoja de datos
    const wsData = wb.addWorksheet('Datos');
    const rows = getR13Data ? getR13Data() : [];
    if (rows && rows.length > 0) {
      const sociaInfo = rows[0];
      const sociaName = `${sociaInfo.sociaNombre} ${sociaInfo.sociaApellido}`;
      
      wsData.addRow(['Historial de Talla']);
      wsData.addRow(['Socia:', sociaName]);
      wsData.addRow(['ID Socia:', sociaInfo.sociaId]);
      wsData.addRow([]);
      
      wsData.addRow(['Fecha de Registro', 'Talla (cm)']);
      rows.forEach(row => {
        wsData.addRow([
          new Date(row.fechaRegistro).toLocaleDateString('es-ES'),
          parseFloat(row.tallaCm)
        ]);
      });

      wsData.columns = [
        { width: 20 },
        { width: 15 }
      ];
    }

    const buffer = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      `FEPAST_historial_talla.xlsx`);
  } catch (error) {
    console.error('Error al generar Excel con gráfico (r13):', error);
    alert('Hubo un error al generar el Excel con gráfico. Por favor, inténtelo de nuevo.');
  }
};


const SimpleTable = ({ columns, data, empty = 'Sin datos' }) => (
  <div className="table-container">
    <table className="data-table">
      <thead>
        <tr>{columns.map(c => <th key={c.key}>{c.header}</th>)}</tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr><td colSpan={columns.length} className="empty"><i className="fas fa-inbox"></i> {empty}</td></tr>
        ) : data.map((row, idx) => (
          <tr key={row.id || idx}>
            {columns.map(c => <td key={c.key}>{c.render ? c.render(row[c.key], row) : row[c.key]}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);


// Gráfico de barras vertical simple en SVG
const VBarChart = ({ title, data, maxValue, height = 240 }) => {
  const padding = 28;
  const barGap = 12;
  const minBarWidth = 24;
  const chartWidth = Math.max(320, data.length * (minBarWidth + barGap) + padding * 2);
  const innerHeight = height - padding * 2;
  const scaleY = (v) => (maxValue > 0 ? (v / maxValue) * innerHeight : 0);
  const barWidth = Math.max(minBarWidth, (chartWidth - padding * 2 - (data.length - 1) * barGap) / data.length);
  return (
    <div style={{ overflowX: 'auto' }}>
      <svg viewBox={`0 0 ${chartWidth} ${height}`} width="100%" height={height} style={{ background: 'var(--surface-hover)', borderRadius: 8 }}>
        {/* Título */}
        {title && (
          <text x={padding} y={18} fontSize="12" fill="var(--text-color)">{title}</text>
        )}
        {/* Eje Y */}
        <line x1={padding} y1={height - padding} x2={chartWidth - padding} y2={height - padding} stroke="#ccc" />
        {/* Barras */}
        {data.map((d, i) => {
          const h = scaleY(d.value);
          const x = padding + i * (barWidth + barGap);
          const y = height - padding - h;
          return (
            <g key={i}>
              <rect x={x} y={y} width={barWidth} height={h}
                fill="url(#gradV)" rx="4" />
              {/* Valor sobre la barra */}
              <text x={x + barWidth / 2} y={y - 4} textAnchor="middle" fontSize="10" fill="var(--text-muted)">{d.value}</text>
              {/* Etiqueta */}
              <text x={x + barWidth / 2} y={height - padding + 12} textAnchor="middle" fontSize="10" fill="var(--text-muted)">{d.label}</text>
            </g>
          );
        })}
        {/* Gradiente */}
        <defs>
          <linearGradient id="gradV" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="var(--primary-color)" />
            <stop offset="100%" stopColor="#66bb6a" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

// Gráfico de barras horizontal simple en SVG
const HBarChart = ({ title, data, maxValue, heightPerItem = 30, barColor = 'var(--primary-color)' }) => {
  const padding = 32;
  const gap = 12;
  const chartHeight = Math.max(100, data.length * (heightPerItem + gap) + padding * 2 + 20);
  const chartWidth = 700;
  const innerWidth = chartWidth - padding * 2 - 140; // Espacio para labels y valores
  const scaleX = (v) => (maxValue > 0 ? (v / maxValue) * innerWidth : 0);
  return (
    <div style={{ overflowX: 'auto', marginBottom: 16 }}>
      <svg viewBox={`0 0 ${chartWidth} ${chartHeight}`} width="100%" height={chartHeight} style={{ background: 'var(--surface-hover)', borderRadius: 8, minHeight: '200px' }}>
        {title && (
          <text x={padding} y={20} fontSize="13" fontWeight="600" fill="var(--text-color)">{title}</text>
        )}
        {data.map((d, i) => {
          const w = Math.max(4, scaleX(d.value)); // Ancho mínimo de 4px para visibilidad
          const y = padding + (title ? 20 : 0) + i * (heightPerItem + gap);
          return (
            <g key={i}>
              <text x={padding} y={y + heightPerItem / 2} dominantBaseline="middle" fontSize="11" fill="var(--text-muted)" fontWeight="500">{d.label}</text>
              <rect x={padding + 140} y={y + 2} width={w} height={heightPerItem - 4} fill={barColor} rx="4" />
              <text x={padding + 140 + w + 8} y={y + heightPerItem / 2} dominantBaseline="middle" fontSize="11" fill="var(--text-color)" fontWeight="600">{d.value}</text>
            </g>
          );
        })}
      </svg>
    </div>
  );
};

function Reports() {
  const [tiposSocias, setTiposSocias] = useState([]);
  const [socias, setSocias] = useState([]);
  const [mentores, setMentores] = useState([]);
  const [caracteristicas, setCaracteristicas] = useState([]);
  const [loadingCaracteristicas] = useState(false);
  const [errorCaracteristicas] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Estado para r15
  const [tratamientosSocia, setTratamientosSocia] = useState([]);
  const [loadingTratamientos, setLoadingTratamientos] = useState(false);
  const [errorTratamientos, setErrorTratamientos] = useState(null);
  // Estado para r16
  const [reqCatalogo, setReqCatalogo] = useState([]);
  const [reqEntregados, setReqEntregados] = useState([]); // nombres
  const [loadingReq, setLoadingReq] = useState(false);
  const [errorReq, setErrorReq] = useState(null);
  // Estado para r7 (socias por provincia)
  const [sociasProvincia, setSociasProvincia] = useState([]);
  const [loadingProvincia, setLoadingProvincia] = useState(false);
  const [errorProvincia, setErrorProvincia] = useState(null);
  // Estado para r8 (socias por ciudad)
  const [sociasCanton, setSociasCanton] = useState([]);
  const [loadingCanton, setLoadingCanton] = useState(false);
  const [errorCanton, setErrorCanton] = useState(null);
  // Estado para r22 (incidencias de ubicación)
  const [incidencias, setIncidencias] = useState([]);
  const [loadingIncidencias, setLoadingIncidencias] = useState(false);
  const [errorIncidencias, setErrorIncidencias] = useState(null);
  // Estado para r12 (socias afiliadas al IESS)
  const [r12Rows, setR12Rows] = useState([]);
  const [loadingR12, setLoadingR12] = useState(false);
  const [errorR12, setErrorR12] = useState(null);
  // Estado para r13 (talla por socia)
  const [r13Rows, setR13Rows] = useState([]);
  const [loadingR13, setLoadingR13] = useState(false);
  const [errorR13, setErrorR13] = useState(null);
  // Estado para r14 (edad de detección)
  const [r14Data, setR14Data] = useState([]);
  const [loadingR14, setLoadingR14] = useState(false);
  const [errorR14, setErrorR14] = useState(null);

  // Estado para r21 (inventario)
  const [inventoryRows, setInventoryRows] = useState([]);
  const [inventoryLocations, setInventoryLocations] = useState([]);
  const [inventoryCategories, setInventoryCategories] = useState([]);
  const [loadingInventory, setLoadingInventory] = useState(false);
  const [errorInventory, setErrorInventory] = useState(null);

  // Estado para reporte seleccionado (debe declararse antes de usarlo en efectos)
  const reportList = [
    { id: 'r1', title: 'Lista de Socios por tipo de socio', icon: 'fas fa-user-tag' },
    { id: 'r2', title: 'Direcciones y teléfonos', icon: 'fas fa-map-marker-alt' },
    { id: 'r3', title: 'Lista de Socios por tipo de síndrome', icon: 'fas fa-dna' },
    { id: 'r4', title: 'Lista de Socios por estado', icon: 'fas fa-toggle-on' },
    { id: 'r5', title: 'Fechas de cumpleaños', icon: 'fas fa-birthday-cake' },
    { id: 'r6', title: 'Lista de Socios por país', icon: 'fas fa-globe' },
    { id: 'r7', title: 'Lista de Socios por provincia', icon: 'fas fa-map' },
    { id: 'r8', title: 'Lista de Socios por cantón', icon: 'fas fa-city' },
    { id: 'r9', title: 'Incidencia de características', icon: 'fas fa-percentage' },
    { id: 'r10', title: 'Listado asistencia socios', icon: 'fas fa-clipboard-check' },
    { id: 'r11', title: 'Socios con discapacidad', icon: 'fas fa-wheelchair' },
    { id: 'r12', title: 'Socios afiliados al IESS', icon: 'fas fa-id-card' },
    { id: 'r13', title: 'Promedio talla hormona', icon: 'fas fa-ruler-vertical' },
    { id: 'r14', title: 'Edad de detección', icon: 'fas fa-child' },
    { id: 'r15', title: 'Medicamentos y tratamientos', icon: 'fas fa-pills' },
    { id: 'r16', title: 'Documentos entregados/no entregados', icon: 'fas fa-file-alt' },
    { id: 'r17', title: 'Socios registrados en MSP', icon: 'fas fa-hospital' },
    { id: 'r18', title: 'Mentoras', icon: 'fas fa-chalkboard-teacher' },
    { id: 'r19', title: 'Socias agrupadas por mentora', icon: 'fas fa-users' },
    { id: 'r20', title: 'Gráfico de socias por síndrome y ubicación', icon: 'fas fa-project-diagram' },
    { id: 'r21', title: 'Reporte de Inventario', icon: 'fas fa-boxes' },
    { id: 'r22', title: 'Incidencias por ubicación', icon: 'fas fa-map-pin' },
  ];
  const [selectedReport, setSelectedReport] = useState(reportList[0].id);

  // Filtros compartidos (debe declararse antes de usarse en efectos)
  const [filtros, setFiltros] = useState({
    tipoSocio: '', pais: '', provincia: '', canton: '',
    mes: String(new Date().getMonth() + 1).padStart(2, '0'),
    tipoSindrome: '', estado: '', mentora: '',
    sociaId: '',
    msp: '1',
    mentorId: '',
    ubicacionNivel: 'pais',
    discapCarnet: '',
    discapTipo: '',
    discapRango: '',
    discapGrado: '',
    discapPctMin: '',
    discapPctMax: '',
    iessAfiliado: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
          const [tiposSociasData, sociasData, mentoresRes, caracteristicasRes] = await Promise.all([
            getTiposSocias(),
            getSocias(),
            mentorService.getAllMentores().catch(() => ([])),
            getCaracteristicas().catch(() => ([]))
          ]);
          setTiposSocias(tiposSociasData);
          // Intentar enriquecer cada socia con las características persistidas en backend
          const sociasArray = Array.isArray(sociasData) ? sociasData : [];
          try {
            // Mapear nombres de catálogo a ids para poder convertir la respuesta del endpoint por socia
            const nameToId = new Map((chars || []).map(ch => [String(ch.CARACTERISTICA_NOMBRE || ch.nombre || ch.name || ''), String(ch.CARACTERISTICA_ID || ch.id || ch.ID || '')]));
            const enrichedPromises = sociasArray.map(async (s) => {
              try {
                const lista = await sociasCaracteristicasService.listBySocia(s.sociaId || s.id || s.SOCIA_ID || '');
                const nombres = Array.isArray(lista) ? lista.map(x => x.CARACTERISTICA_NOMBRE || x.nombre || x.caracteristica || x.NOMBRE).filter(Boolean) : [];
                const ids = nombres.map(n => nameToId.get(n)).filter(Boolean);
                return { ...s, caracteristicasPresentes: ids };
              } catch (e) {
                // Si falla una petición por socia, no impedir el resto
                return { ...s };
              }
            });
            const enriched = await Promise.all(enrichedPromises);
            setSocias(enriched);
          } catch (e) {
            // Si algo falla al enriquecer, usamos el dataset tal cual
            setSocias(sociasData);
          }
          const mentoresData = mentoresRes?.data || mentoresRes || [];
          setMentores(Array.isArray(mentoresData) ? mentoresData : []);
          // Normalizar caracteristicas si viene como response axios
          const chars = Array.isArray(caracteristicasRes?.data) ? caracteristicasRes.data : (Array.isArray(caracteristicasRes) ? caracteristicasRes : []);
          setCaracteristicas(chars.map(it => ({
            id: it.CARACTERISTICA_ID || it.id || it.ID || String(it.CARACTERISTICA_ID || it.id || it.ID || ''),
            nombre: it.CARACTERISTICA_NOMBRE || it.nombre || it.name || '',
            observacion: it.CARACTERISTICA_OBSERVACION || it.observacion || it.observation || ''
          })));
        } catch (err) {
        setError(err.message);
        console.error('Error al cargar datos:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Cargar datos para r7 (socias por provincia)
  useEffect(() => {
    if (selectedReport !== 'r7') return;
    setLoadingProvincia(true);
    setErrorProvincia(null);
    getSociasPorProvincia()
      .then(data => setSociasProvincia(Array.isArray(data) ? data : []))
      .catch(err => setErrorProvincia(err?.response?.data?.error || err.message || 'Error al cargar reporte por provincia'))
      .finally(() => setLoadingProvincia(false));
  }, [selectedReport]);

  // Cargar datos para r8 (socias por ciudad)
  useEffect(() => {
    if (selectedReport !== 'r8') return;
    setLoadingCanton(true);
    setErrorCanton(null);
    getSociasPorCanton()
      .then(data => setSociasCanton(Array.isArray(data) ? data : []))
      .catch(err => setErrorCanton(err?.response?.data?.error || err.message || 'Error al cargar reporte por ciudad'))
      .finally(() => setLoadingCanton(false));
  }, [selectedReport]);

  // Cargar datos para r22 (incidencias por ubicación)
  useEffect(() => {
    if (selectedReport !== 'r22') return;
    setLoadingIncidencias(true);
    setErrorIncidencias(null);
    getIncidenciasUbicacion({ nivel: filtros.ubicacionNivel || 'pais' })
      .then((resp) => {
        // El endpoint devuelve { nivel, data } o un array directo
        const rows = Array.isArray(resp?.data) ? resp.data : (Array.isArray(resp) ? resp : []);
        setIncidencias(rows);
      })
      .catch(err => setErrorIncidencias(err?.response?.data?.error || err.message || 'Error al cargar incidencias de ubicación'))
      .finally(() => setLoadingIncidencias(false));
  }, [selectedReport, filtros.ubicacionNivel]);

  // Cargar datos para r12 (socias afiliadas al IESS)
  useEffect(() => {
    if (selectedReport !== 'r12') return;
    setLoadingR12(true);
    setErrorR12(null);
    const params = {};
    if (filtros.iessAfiliado) params.afiliado = filtros.iessAfiliado;

    getSociasAfiliadasIESS(params)
      .then((resp) => {
        const rows = Array.isArray(resp?.data) ? resp.data : (Array.isArray(resp) ? resp : []);
        setR12Rows(rows);
      })
      .catch(err => setErrorR12(err?.response?.data?.error || err.message || 'Error al cargar socias afiliadas al IESS'))
      .finally(() => setLoadingR12(false));
  }, [selectedReport, filtros.iessAfiliado]);

  // Cargar datos para r13 (talla por socia)
  useEffect(() => {
    if (selectedReport !== 'r13') return;
    setLoadingR13(true);
    setErrorR13(null);

    const params = {};
    if (filtros.sociaId) params.sociaId = filtros.sociaId;
    if (filtros.fechaInicio) params.fechaInicio = filtros.fechaInicio;
    if (filtros.fechaFin) params.fechaFin = filtros.fechaFin;

    getTallaPorSocia(params)
      .then((resp) => {
        const rows = Array.isArray(resp?.data) ? resp.data : (Array.isArray(resp) ? resp : []);
        setR13Rows(rows);
      })
      .catch(err => setErrorR13(err?.response?.data?.error || err.message || 'Error al cargar datos de talla'))
      .finally(() => setLoadingR13(false));
  }, [selectedReport, filtros.sociaId, filtros.fechaInicio, filtros.fechaFin]);

  // Cargar datos para r14 (edad de detección por país)
  useEffect(() => {
    if (selectedReport !== 'r14') return;
    setLoadingR14(true);
    setErrorR14(null);

    getEdadDeteccion()
      .then((resp) => {
        const data = Array.isArray(resp?.data) ? resp.data : (Array.isArray(resp) ? resp : []);
        setR14Data(data);
      })
      .catch(err => setErrorR14(err?.response?.data?.error || err.message || 'Error al cargar datos de edad de detección'))
      .finally(() => setLoadingR14(false));
  }, [selectedReport]);

  // Cargar datos para r21 (Reporte de Inventario)
  useEffect(() => {
    if (selectedReport !== 'r21') return;
    setLoadingInventory(true);
    setErrorInventory(null);
    (async () => {
      try {
        const [prodRes, locRes, catRes] = await Promise.all([
          inventoryService.products.getProducts(1, 1000, ''),
          inventoryService.locations.getLocations(),
          inventoryService.categories.getCategories()
        ]);

        // Normalizar productos
        let products = [];
        if (prodRes) {
          if (prodRes.success) {
            const payload = prodRes.data;
            if (Array.isArray(payload)) products = payload;
            else if (payload && Array.isArray(payload.data)) products = payload.data;
            else products = [];
          } else if (Array.isArray(prodRes)) {
            products = prodRes;
          }
        }

        setInventoryRows(products);
        setInventoryLocations((locRes && locRes.success) ? (locRes.data || []) : (Array.isArray(locRes) ? locRes : []));
        setInventoryCategories((catRes && catRes.success) ? (catRes.data || []) : (Array.isArray(catRes) ? catRes : []));
      } catch (err) {
        console.error('Error al cargar inventario para r21:', err);
        setErrorInventory(err?.response?.data?.message || err.message || 'Error al cargar inventario');
      } finally {
        setLoadingInventory(false);
      }
    })();
  }, [selectedReport]);

  // Filtros compartidos (declarado antes)
  const selectedSocia = useMemo(() => socias.find(s => s.sociaId === filtros.sociaId) || null, [socias, filtros.sociaId]);

  const changeFiltro = (e) => setFiltros(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const clearFiltro = (name) => setFiltros(prev => ({ ...prev, [name]: '' }));

  // Enriquecer las socias con las características persistidas en backend
  useEffect(() => {
    const enrich = async () => {
      if (!Array.isArray(socias) || socias.length === 0) return;
      if (!Array.isArray(caracteristicas) || caracteristicas.length === 0) return;
      // Solo procesar socias que no tengan ya caracteristicasPresentes
      const toFetch = socias.filter(s => !Array.isArray(s.caracteristicasPresentes) || s.caracteristicasPresentes.length === 0);
      if (toFetch.length === 0) return;
      const nameToId = new Map(caracteristicas.map(c => [String(c.nombre || c.CARACTERISTICA_NOMBRE || ''), String(c.id || c.CARACTERISTICA_ID || c.ID || '')]));
      try {
        const promises = toFetch.map(async (s) => {
          try {
            const lista = await sociasCaracteristicasService.listBySocia(s.sociaId || s.id || s.SOCIA_ID || '');
            const nombres = Array.isArray(lista) ? lista.map(x => x.CARACTERISTICA_NOMBRE || x.nombre || x.caracteristica || x.NOMBRE).filter(Boolean) : [];
            const ids = nombres.map(n => nameToId.get(n)).filter(Boolean);
            return { idKey: s.sociaId || s.id || s.SOCIA_ID || '', ids };
          } catch (e) {
            return { idKey: s.sociaId || s.id || s.SOCIA_ID || '', ids: [] };
          }
        });
        const results = await Promise.all(promises);
        const mapById = new Map(results.map(r => [String(r.idKey), r.ids]));
        setSocias(prev => prev.map(s => {
          const key = String(s.sociaId || s.id || s.SOCIA_ID || '');
          if (mapById.has(key)) {
            return { ...s, caracteristicasPresentes: mapById.get(key) };
          }
          return s;
        }));
      } catch (err) {
        console.debug('No se pudieron enriquecer características por socia:', err?.message || err);
      }
    };
    enrich();
  }, [socias, caracteristicas]);

  // Cargar tratamientos cuando se seleccione r15 y una socia
  useEffect(() => {
    const fetchTratamientos = async () => {
      if (selectedReport !== 'r15' || !filtros.sociaId) {
        setTratamientosSocia([]);
        return;
      }
      setLoadingTratamientos(true);
      setErrorTratamientos(null);
      try {
        const data = await getTratamientosPorSocia(filtros.sociaId);
        setTratamientosSocia(Array.isArray(data) ? data : []);
      } catch (err) {
        setErrorTratamientos(err?.response?.data?.message || err.message || 'Error al cargar tratamientos');
      } finally {
        setLoadingTratamientos(false);
      }
    };
    fetchTratamientos();
  }, [selectedReport, filtros.sociaId]);

  // Cargar requisitos para r16 (catálogo + entregados por socia)
  useEffect(() => {
    const fetchReq = async () => {
      if (selectedReport !== 'r16' || !filtros.sociaId) {
        setReqCatalogo([]);
        setReqEntregados([]);
        setErrorReq(null);
        return;
      }
      setLoadingReq(true);
      setErrorReq(null);
      try {
        const [cat, entregadosRaw] = await Promise.all([
          requisitosService.getAllRequisitos(),
          sociasRequisitosService.listBySocia(filtros.sociaId)
        ]);
        const catalogo = Array.isArray(cat) ? cat.map(r => ({ id: r.id, nombre: r.nombre, descripcion: r.descripcion })) : [];
        const entregadosNombres = Array.isArray(entregadosRaw) ? entregadosRaw.map(x => x.REQUISITOS_NOMBRE || x.nombre).filter(Boolean) : [];
        setReqCatalogo(catalogo);
        setReqEntregados(entregadosNombres);
      } catch (err) {
        console.error('Error al cargar requisitos para reporte r16:', err);
        setErrorReq(err?.response?.data?.message || err.message || 'Error al cargar requisitos');
      } finally {
        setLoadingReq(false);
      }
    };
    fetchReq();
  }, [selectedReport, filtros.sociaId]);

  // Se eliminaron calculos basados en mockPartners; los reportes usan datos reales de 'socias'

  // ...otros reportes y lógica...
  // Lista de países únicos extraída de las socias
  const uniqueCountries = useMemo(() => {
    return Array.from(new Set(socias.map(s => s.sociaPais).filter(Boolean)));
  }, [socias]);

  // Lista de provincias únicas (para filtro r7)
  const uniqueProvinces = useMemo(() => {
    return Array.from(new Set((socias || []).map(s => s.sociaProvincia).filter(Boolean))).sort();
  }, [socias]);

  // r8: datos fallback agrupados desde 'socias' si el endpoint devuelve vacío
  const fallbackSociasCanton = useMemo(() => {
    if (!Array.isArray(socias) || socias.length === 0) return [];
    const map = new Map();
    socias.forEach(s => {
      // considerar activas en ambas variantes: 'ACTIVO' o 'Activo'
      const estado = (s.sociaEstado || '').toString();
      const activa = estado.toUpperCase() === 'ACTIVO';
      if (!activa) return;
      const provincia = s.sociaProvincia || null;
      const ciudad = s.sociaCiudad || null;
      const key = `${provincia || 'Sin provincia'}|${ciudad || 'Sin ciudad'}`;
      if (!map.has(key)) {
        map.set(key, {
          sociaProvincia: provincia,
          canton: ciudad,
          totalSocias: 0,
          socias: []
        });
      }
      const entry = map.get(key);
      entry.totalSocias += 1;
      entry.socias.push(`${s.sociaNombre || ''} ${s.sociaApellido || ''} (${s.sociaCedula || s.sociaId || ''})`.trim());
    });
    return Array.from(map.values()).map(r => ({
      ...r,
      socias: r.socias.join('; ')
    }));
  }, [socias]);

  // r8: dataset efectivo (API si hay datos, fallback si viene vacío)
  const r8Data = useMemo(() => (Array.isArray(sociasCanton) && sociasCanton.length > 0 ? sociasCanton : fallbackSociasCanton), [sociasCanton, fallbackSociasCanton]);

  // r8: Provincias únicas desde dataset efectivo
  const uniqueProvincesR8 = useMemo(() => {
    return Array.from(new Set((r8Data || [])
      .map(r => r.sociaProvincia || r.provincia)
      .filter(Boolean))).sort();
  }, [r8Data]);

  // r8: Ciudades únicas desde dataset efectivo (dependen de provincia)
  const uniqueCantonsR8 = useMemo(() => {
    const filtered = (r8Data || []).filter(r => !filtros.provincia || (r.sociaProvincia || r.provincia) === filtros.provincia);
    return Array.from(new Set(filtered
      .map(r => r.sociaCanton || r.sociaCiudad || r.canton)
      .filter(Boolean))).sort();
  }, [r8Data, filtros.provincia]);

  // r8: limpiar filtros inválidos
  useEffect(() => {
    if (selectedReport !== 'r8') return;
    if (filtros.provincia && !uniqueProvincesR8.includes(filtros.provincia)) {
      setFiltros(prev => ({ ...prev, provincia: '' }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedReport, uniqueProvincesR8]);

  useEffect(() => {
    if (selectedReport !== 'r8') return;
    if (filtros.canton && !uniqueCantonsR8.includes(filtros.canton)) {
      setFiltros(prev => ({ ...prev, canton: '' }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedReport, filtros.provincia, uniqueCantonsR8]);

  // Socias cuyo mes de cumpleaños coincide con el filtro
  const sociosByBirthMonth = useMemo(() => {
    return socias.filter(s => {
      if (!s.sociaFechaNacimiento) return false;
      const m = String(new Date(s.sociaFechaNacimiento).getMonth() + 1).padStart(2, '0');
      return m === filtros.mes;
    });
  }, [socias, filtros.mes]);

  const computeAgeTurning = (birthDateStr, year = new Date().getFullYear()) => {
    if (!birthDateStr) return '';
    const d = new Date(birthDateStr);
    const birthYear = d.getFullYear();
    return year - birthYear;
  };

  // r14: Procesamiento de datos de edad de detección por país (desde backend)
  const edadDeteccionByCountry = useMemo(() => {
    if (!r14Data || r14Data.length === 0) return { rows: [], maxAvg: 1 };
    const maxAvg = r14Data.reduce((m, r) => Math.max(m, r.avg || 0), 0) || 1;
    return { rows: r14Data, maxAvg };
  }, [r14Data]);

  // r14 extra: Distribución por rangos de edad (global)
  const edadDeteccionRangos = useMemo(() => {
    if (!r14Data || r14Data.length === 0) return { counts: [], max: 1 };
    // Obtener todas las edades de todos los países
    const valores = r14Data.flatMap(item => item.edades || []);
    const rangosDef = [
      { label: '0-2', min: 0, max: 2.999 },
      { label: '3-5', min: 3, max: 5.999 },
      { label: '6-10', min: 6, max: 10.999 },
      { label: '11-15', min: 11, max: 15.999 },
      { label: '16+', min: 16, max: Infinity },
    ];
    const counts = rangosDef.map(r => ({ label: r.label, value: 0 }));
    valores.forEach(v => {
      const idx = rangosDef.findIndex(r => v >= r.min && v <= r.max);
      if (idx >= 0) counts[idx].value += 1;
    });
    const max = counts.reduce((m, r) => Math.max(m, r.value), 0) || 1;
    return { counts, max };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socias]);

  return (
    <div className="reports-container" style={{ display: 'flex', gap: '2rem', minHeight: '70vh', maxWidth: '100%', overflow: 'hidden' }}>
      {/* Menú lateral moderno */}
      <aside style={{ minWidth: 260, maxWidth: 320, background: 'var(--surface-hover)', borderRadius: 12, boxShadow: 'var(--shadow-xs)', padding: '1.2rem 0.7rem', display: 'flex', flexDirection: 'column', gap: 8, overflowY: 'auto' }}>
        <h2 style={{ fontSize: '1.15rem', marginBottom: 12, color: 'var(--primary-color)' }}>Selecciona el reporte</h2>
        {reportList.map(r => (
          <button
            key={r.id}
            className={`subnav-item${selectedReport === r.id ? ' selected' : ''}`}
            style={{ width: '100%', justifyContent: 'flex-start', fontWeight: selectedReport === r.id ? 'bold' : 'normal', background: selectedReport === r.id ? 'rgba(var(--primary-color-rgb),0.08)' : undefined, borderColor: selectedReport === r.id ? 'rgba(var(--primary-color-rgb),0.25)' : undefined }}
            onClick={() => setSelectedReport(r.id)}
          >
            <i className={r.icon}></i>
            <span>{r.title}</span>
          </button>
        ))}
      </aside>

      {/* Panel derecho: filtros, acciones y previsualización */}
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 16, minWidth: 0, overflow: 'hidden' }}>
        <div className="reports-header" style={{ marginBottom: 0 }}>
          <h1>Reportes</h1>
          <p>Vista previa y exportación de reportes</p>
        </div>

      <div className="filters-grid">
        {/* Filtros específicos por reporte */}
        {selectedReport === 'r1' && (
          <div className="form-group">
            <label>Seleccione un Tipo de Socia</label>
            <select name="tipoSocio" value={filtros.tipoSocio} onChange={changeFiltro}>
    
              {tiposSocias.map(tipo => (
                <option key={tipo.TS} value={tipo.TS}>
                  {tipo.TIPOSOCIA_NOMBRE}
                </option>
              ))}
            </select>
          </div>
        )}

    {selectedReport === 'r3' && (
          <div className="form-group">
            <label>Tipo de Sindrome</label>
            <select name="tipoSindrome" value={filtros.estado} onChange={changeFiltro}>
              <option value="Monosomía X completa (45,X)">Monosomía X completa (45,X)</option>
                                        <option value="Mosaicismo 45,X/46,XX">Mosaicismo 45,X/46,XX</option>
                                        <option value="Mosaicismo 45,X/47,XXX">Mosaicismo 45,X/47,XXX</option>
                                        <option value="Mosaicismo 45,X/46,XY">Mosaicismo 45,X/46,XY</option>
                                        <option value="Mosaicismo 45,X/46,X,i(Xq)">Mosaicismo 45,X/46,X,i(Xq)</option>
                                        <option value="Mosaicismo 45,X/46,X,r(X)">Mosaicismo 45,X/46,X,r(X)</option>
                                        <option value="Deleción del brazo corto del cromosoma">Deleción del brazo corto del cromosoma</option>
                                        <option value="Deleción del brazo largo del cromosoma">Deleción del brazo largo del cromosoma</option>
                                        <option value="Isochromosoma del brazo largo del X">Isochromosoma del brazo largo del X</option>
                                        <option value="Cromosoma en anillo del X">Cromosoma en anillo del X</option>
                                        <option value="Mosaicismo triple">Mosaicismo triple</option>
                                        <option value="Mosaicismo complejo">Mosaicismo complejo</option>
                                        <option value="Translocación entre dos cromosomas X">Translocación entre dos cromosomas X</option>
                                        <option value="Translocación entre X y un autosoma">Translocación entre X y un autosoma</option>
                                        <option value="Translocación entre X y Y">Translocación entre X y Y</option>
                                        <option value="Duplicación parcial del X">Duplicación parcial del X</option>
                                        <option value="Inversión del cromosoma">Inversión del cromosoma</option>
                                        <option value="Cromosoma X dicéntrico">Cromosoma X dicéntrico</option>
                                        <option value="Cromosoma en anillo derivado del Y">Cromosoma en anillo derivado del Y</option>
                                        <option value="Monosomía X parcial">Monosomía X parcial</option>
            </select>
          </div>
        )}

        {selectedReport === 'r4' && (
          <div className="form-group">
            <label>Estado de las Socias</label>
            <select name="estado" value={filtros.estado} onChange={changeFiltro}>
              <option value="">Todos</option>
              <option value="Activo">Activo</option>
              <option value="Inactivo">Inactivo</option>
            </select>
          </div>
        )}

        {selectedReport === 'r5' && (
          <div className="form-group">
            <label>Mes</label>
            <select name="mes" value={filtros.mes} onChange={changeFiltro}>
              {['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'].map((m,i) => (
                <option key={i} value={String(i+1).padStart(2,'0')}>{m}</option>
              ))}
            </select>
          </div>
        )}

        {selectedReport === 'r6' && (
          <div className="form-group">
            <label>País</label>
            <select name="pais" value={filtros.pais} onChange={changeFiltro}>
              <option value="">Todos</option>
              {uniqueCountries.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        )}
        {selectedReport === 'r7' && (
          <div className="form-group">
            <label>Provincia</label>
            <select name="provincia" value={filtros.provincia} onChange={changeFiltro}>
              <option value="">Todas</option>
              {uniqueProvinces.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
        )}
        {selectedReport === 'r8' && (
          <>
            <div className="form-group">
              <label>Provincia</label>
              <select name="provincia" value={filtros.provincia} onChange={changeFiltro}>
                <option value="">Todas</option>
                {uniqueProvincesR8.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Cantón</label>
              <select name="canton" value={filtros.canton} onChange={changeFiltro}>
                <option value="">Todas</option>
                {uniqueCantonsR8.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </>
        )}
        {selectedReport === 'r11' && (
          <>
            <div className="form-group">
              <label>Carnet de discapacidad</label>
              <select name="discapCarnet" value={filtros.discapCarnet} onChange={changeFiltro}>
                <option value="">Todos</option>
                <option value="SI">Sí</option>
                <option value="NO">No</option>
              </select>
            </div>
            <div className="form-group">
              <label>Tipo de discapacidad</label>
              <select name="discapTipo" value={filtros.discapTipo} onChange={changeFiltro}>
                <option value="">Todos</option>
                {['Física','Auditiva','Lenguaje','Intelectual','Psicosocial','Múltiple'].map(t => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Grado</label>
              <select name="discapGrado" value={filtros.discapGrado} onChange={changeFiltro}>
                <option value="">Todos</option>
                {['Leve o ligera','Moderada','Grave','Muy grave o severa','Discapacidad completa'].map(g => (
                  <option key={g} value={g}>{g}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Rango de porcentaje</label>
              <select name="discapRango" value={filtros.discapRango} onChange={changeFiltro}>
                <option value="">Todos</option>
                <option value="0-29">0% - 29%</option>
                <option value="30-49">30% - 49%</option>
                <option value="50-74">50% - 74%</option>
                <option value="75-100">75% - 100%</option>
              </select>
            </div>
            <div className="form-group">
              <label>% mínimo</label>
              <input type="number" name="discapPctMin" min="0" max="100" value={filtros.discapPctMin} onChange={changeFiltro} placeholder="0" />
            </div>
            <div className="form-group">
              <label>% máximo</label>
              <input type="number" name="discapPctMax" min="0" max="100" value={filtros.discapPctMax} onChange={changeFiltro} placeholder="100" />
            </div>
          </>
        )}
        {selectedReport === 'r12' && (
          <div className="form-group">
            <label>Afiliado al IESS</label>
            <select name="iessAfiliado" value={filtros.iessAfiliado} onChange={changeFiltro}>
              <option value="">Todos</option>
              <option value="SI">Sí</option>
              <option value="NO">No</option>
            </select>
          </div>
        )}
        {selectedReport === 'r13' && (
          <>
            <div className="form-group">
              <label>Socia</label>
              <select
                name="sociaId"
                value={filtros.sociaId || ''}
                onChange={changeFiltro}
              >
                <option value="">Seleccione una socia</option>
                {socias.map(s => (
                  <option key={s.sociaId} value={s.sociaId}>
                    {s.sociaNombre} {s.sociaApellido} ({s.sociaId})
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Fecha Inicio</label>
              <input
                type="date"
                name="fechaInicio"
                value={filtros.fechaInicio || ''}
                onChange={changeFiltro}
              />
            </div>
            <div className="form-group">
              <label>Fecha Fin</label>
              <input
                type="date"
                name="fechaFin"
                value={filtros.fechaFin || ''}
                onChange={changeFiltro}
              />
            </div>
          </>
        )}
        {selectedReport === 'r22' && (
          <div className="form-group">
            <label>Nivel</label>
            <select name="ubicacionNivel" value={filtros.ubicacionNivel} onChange={changeFiltro}>
              <option value="pais">País</option>
              <option value="provincia">Provincia</option>
              <option value="ciudad">Ciudad</option>
            </select>
          </div>
        )}
        {selectedReport === 'r20' && (
          <>
            <div className="form-group">
              <label>Tipo de Síndrome</label>
              <select name="tipoSindrome" value={filtros.tipoSindrome} onChange={changeFiltro}>
                <option value="">Todos</option>
                {Array.from(new Set((socias || []).map(s => s.sociaTipoSindrome).filter(Boolean))).map((ts) => (
                  <option key={ts} value={ts}>{ts}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>País</label>
              <select name="pais" value={filtros.pais} onChange={changeFiltro}>
                <option value="">Todos</option>
                {uniqueCountries.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </>
        )}

        {selectedReport === 'r17' && (
          <div className="form-group">
            <label>Registro en MSP</label>
            <select name="msp" value={filtros.msp} onChange={changeFiltro}>
              <option value="">Todos</option>
              <option value="1">Registradas</option>
              <option value="0">No registradas</option>
            </select>
          </div>
        )}

        {selectedReport === 'r15' && (
          <div className="form-group">
            <label>Socia</label>
            <select name="sociaId" value={filtros.sociaId} onChange={changeFiltro}>
              <option value="">Seleccione una socia</option>
              {socias.map((s) => (
                <option key={s.sociaId} value={s.sociaId}>
                  {s.sociaNombre} {s.sociaApellido} ({s.sociaId})
                </option>
              ))}
            </select>
          </div>
        )}
        {selectedReport === 'r16' && (
          <div className="form-group">
            <label>Socia</label>
            <select name="sociaId" value={filtros.sociaId} onChange={changeFiltro}>
              <option value="">Seleccione una socia</option>
              {socias.map((s) => (
                <option key={s.sociaId} value={s.sociaId}>
                  {s.sociaNombre} {s.sociaApellido} ({s.sociaId})
                </option>
              ))}
            </select>
          </div>
        )}

        {selectedReport === 'r19' && (
          <div className="form-group">
            <label>Mentora</label>
            <select name="mentorId" value={filtros.mentorId} onChange={changeFiltro}>
              <option value="">Todas</option>
              {mentores.map((m) => (
                <option key={m.mentorId} value={m.mentorId}>
                  {m.mentorNombre} {m.mentorSector ? `- ${m.mentorSector}` : ''}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>


        <div className="filters-chips">
          {Object.entries(filtros).map(([k, v]) => v && (
            <span key={k} className="chip chip-info" title="Quitar filtro" onClick={() => clearFiltro(k)}>
              <i className="fas fa-filter"></i> {(
                k === 'canton' ? 'cantón' :
                k === 'discapCarnet' ? 'carnet discapacidad' :
                k === 'discapTipo' ? 'tipo discapacidad' :
                k === 'discapRango' ? 'rango %' :
                k === 'discapGrado' ? 'grado' :
                k === 'discapPctMin' ? '% mín' :
                k === 'discapPctMax' ? '% máx' :
                k
              )}: {v} <i className="fas fa-times"></i>
            </span>
          ))}
        </div>

        {/* Botones de exportación sobre la previsualización */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 12, justifyContent: 'flex-end' }}>
          <button className="btn" onClick={handlePrint}>
    <i className="fas fa-print"></i> Imprimir
  </button>
  <button className="btn" onClick={handlePDF}>
    <i className="fas fa-file-pdf"></i> PDF
  </button>
  <button className="btn" onClick={handleExcel}>
    <i className="fas fa-file-excel"></i> Excel
  </button>
  {selectedReport === 'r14' && (
    <button
      className="btn"
      onClick={() => handleExcelWithCharts(() => ({ rows: edadDeteccionByCountry.rows, rangos: edadDeteccionRangos.counts }))}
      title="Exporta una hoja con los gráficos como imágenes y otra hoja con los datos"
    >
      <i className="fas fa-file-excel"></i> Excel (gráficos)
    </button>
  )}
  {selectedReport === 'r20' && (
    <button
      className="btn"
      onClick={() => handleExcelWithChartsR20(() => {
        // Recalcular datos r20 para export
        const mapPais = new Map();
        (socias || []).forEach(s => {
          const pais = s?.sociaPais || 'No especificado';
          const ts = s?.sociaTipoSindrome || '';
          if (filtros.tipoSindrome && ts !== filtros.tipoSindrome) return;
          mapPais.set(pais, (mapPais.get(pais) || 0) + 1);
        });
        const rowsPais = Array.from(mapPais.entries()).map(([label, value]) => ({ label, value })).sort((a,b) => b.value - a.value);
        let rowsTs = [];
        if (filtros.pais) {
          const mapTs = new Map();
          (socias || []).forEach(s => {
            if ((s?.sociaPais || '') !== filtros.pais) return;
            const ts = s?.sociaTipoSindrome || 'No especificado';
            mapTs.set(ts, (mapTs.get(ts) || 0) + 1);
          });
          rowsTs = Array.from(mapTs.entries()).map(([label, value]) => ({ label, value })).sort((a,b) => b.value - a.value);
        }
        return { rowsPais, rowsTs, paisSeleccionado: filtros.pais };
      })}
      title="Exporta una hoja con los gráficos como imágenes y otra hoja con los datos"
    >
      <i className="fas fa-file-excel"></i> Excel (gráficos)
    </button>
  )}
  {selectedReport === 'r13' && filtros.sociaId && r13Rows.length > 0 && (
    <button
      className="btn"
      onClick={() => handleExcelWithChartsR13(() => r13Rows)}
      title="Exporta una hoja con el gráfico como imagen y otra hoja con los datos"
    >
      <i className="fas fa-file-excel"></i> Excel (gráfico)
    </button>
  )}
  </div>
        {/* Panel de previsualización dinámico */}
        <div className="report-preview-panel" style={{ flex: 1, background: 'var(--surface-color)', borderRadius: 12, boxShadow: 'var(--shadow-xs)', padding: '1.2rem', minHeight: 320, maxHeight: 'calc(100vh - 200px)', overflow: 'auto', maxWidth: '100%' }}>
           <HeaderReport />
          {selectedReport === 'r7' && (
            <div className="report-content">
              <h2>Lista de Socias por provincia</h2>
              {loadingProvincia ? (
                <div className="loading">Cargando reporte...</div>
              ) : errorProvincia ? (
                <div className="error">{errorProvincia}</div>
              ) : (
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Provincia</th>
                        <th>Total Socias</th>
                        <th>Socias</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const rows = (sociasProvincia || []).filter(r => !filtros.provincia || (r.sociaProvincia || 'Sin provincia') === filtros.provincia);
                        if (rows.length === 0) {
                          return (<tr><td className="empty" colSpan={3}><i className="fas fa-inbox"></i> Sin datos</td></tr>);
                        }
                        const sorted = [...rows].sort((a,b) => (b.totalSocias||0) - (a.totalSocias||0));
                        return sorted.map((row, idx) => (
                          <tr key={idx}>
                            <td>{row.sociaProvincia || 'Sin provincia'}</td>
                            <td style={{ textAlign: 'center' }}>{row.totalSocias}</td>
                            <td>{row.socias}</td>
                          </tr>
                        ));
                      })()}
                    </tbody>
                    <tfoot>
                      {(() => {
                        const rows = (sociasProvincia || []).filter(r => !filtros.provincia || (r.sociaProvincia || 'Sin provincia') === filtros.provincia);
                        const totalGeneral = rows.reduce((acc, r) => acc + (Number(r.totalSocias) || 0), 0);
                        return (
                          <tr>
                            <td><strong>Total</strong></td>
                            <td style={{ textAlign: 'center' }}><strong>{totalGeneral}</strong></td>
                            <td></td>
                          </tr>
                        );
                      })()}
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          )}
          {selectedReport === 'r8' && (
            <div className="report-content">
              <h2>Lista de Socias por cantón</h2>
              {loadingCanton ? (
                <div className="loading">Cargando reporte...</div>
              ) : errorCanton ? (
                <div className="error">{errorCanton}</div>
              ) : (
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Provincia</th>
                        <th>Cantón</th>
                        <th style={{ textAlign: 'center' }}>Total Socias</th>
                        <th>Socias</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const rows = (r8Data || []).filter(row => {
                          const prov = row.sociaProvincia || row.provincia || '';
                          const ciudad = row.sociaCanton || row.sociaCiudad || row.canton || '';
                          if (filtros.provincia && prov !== filtros.provincia) return false;
                          if (filtros.canton && ciudad !== filtros.canton) return false;
                          return true;
                        });
                        if (rows.length === 0) {
                          return (
                            <tr><td className="empty" colSpan={4}><i className="fas fa-inbox"></i> Sin datos</td></tr>
                          );
                        }
                        const sorted = [...rows].sort((a,b) => (b.totalSocias||0) - (a.totalSocias||0));
                        return sorted.map((row, idx) => {
                          const prov = row.sociaProvincia || row.provincia || 'Sin provincia';
                          const ciudad = row.sociaCanton || row.sociaCiudad || row.canton || 'Sin ciudad';
                          return (
                            <tr key={idx}>
                              <td>{prov}</td>
                              <td>{ciudad}</td>
                              <td style={{ textAlign: 'center' }}>{row.totalSocias}</td>
                              {/* mostrar porcentaje a la derecha del total para contexto */}
                              {/* si se prefiere una columna separada, habría que ajustar el thead */}
                              {/* <td style={{ textAlign: 'right' }}>{pct.toFixed(2)}%</td> */}
                              <td>{row.socias}</td>
                            </tr>
                          );
                        });
                      })()}
                    </tbody>
                    <tfoot>
                      {(() => {
                        const rows = (r8Data || []).filter(row => {
                          const prov = row.sociaProvincia || row.provincia || '';
                          const ciudad = row.sociaCanton || row.sociaCiudad || row.canton || '';
                          if (filtros.provincia && prov !== filtros.provincia) return false;
                          if (filtros.canton && ciudad !== filtros.canton) return false;
                          return true;
                        });
                        const totalGeneral = rows.reduce((acc, r) => acc + (Number(r.totalSocias) || 0), 0);
                        return (
                          <tr>
                            <td colSpan={2}><strong>Total</strong></td>
                            <td style={{ textAlign: 'center' }}><strong>{totalGeneral}</strong></td>
                            <td></td>
                          </tr>
                        );
                      })()}
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          )}
          {selectedReport === 'r22' && (
            <div className="report-content">
              <h2 style={{ textAlign: 'center', marginTop: 0, marginBottom: 12 }}>Incidencias por ubicación</h2>
              {loadingIncidencias ? (
                <div className="loading">Cargando incidencias...</div>
              ) : errorIncidencias ? (
                <div className="error">{errorIncidencias}</div>
              ) : (
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      {filtros.ubicacionNivel === 'ciudad' ? (
                        <tr>
                          <th>Provincia</th>
                          <th>Ciudad</th>
                          <th style={{ textAlign: 'center' }}>Total</th>
                        </tr>
                      ) : filtros.ubicacionNivel === 'provincia' ? (
                        <tr>
                          <th>Provincia</th>
                          <th style={{ textAlign: 'center' }}>Total</th>
                        </tr>
                      ) : (
                        <tr>
                          <th>País</th>
                          <th style={{ textAlign: 'center' }}>Total</th>
                        </tr>
                      )}
                    </thead>
                    <tbody>
                      {(() => {
                        const rows = Array.isArray(incidencias) ? incidencias : [];
                        if (rows.length === 0) {
                          return (
                            <tr><td className="empty" colSpan={filtros.ubicacionNivel === 'ciudad' ? 3 : 2}><i className="fas fa-inbox"></i> Sin datos</td></tr>
                          );
                        }
                        const sorted = [...rows].sort((a,b) => (b.total||0) - (a.total||0));
                        return sorted.map((row, idx) => {
                          if (filtros.ubicacionNivel === 'ciudad') {
                            return (
                              <tr key={idx}>
                                <td>{row.provincia || 'Sin provincia'}</td>
                                <td>{row.ciudad || 'Sin ciudad'}</td>
                                <td style={{ textAlign: 'center' }}>{row.total}</td>
                              </tr>
                            );
                          }
                          if (filtros.ubicacionNivel === 'provincia') {
                            return (
                              <tr key={idx}>
                                <td>{row.provincia || 'Sin provincia'}</td>
                                <td style={{ textAlign: 'center' }}>{row.total}</td>
                              </tr>
                            );
                          }
                          return (
                            <tr key={idx}>
                              <td>{row.pais || 'Sin país'}</td>
                              <td style={{ textAlign: 'center' }}>{row.total}</td>
                            </tr>
                          );
                        });
                      })()}
                      {Array.isArray(incidencias) && incidencias.length === 0 && (
                        <tr><td className="empty" colSpan={filtros.ubicacionNivel === 'ciudad' ? 3 : 2}><i className="fas fa-inbox"></i> Sin datos</td></tr>
                      )}
                    </tbody>
                    <tfoot>
                      {(() => {
                        const rows = Array.isArray(incidencias) ? incidencias : [];
                        const totalGeneral = rows.reduce((acc, r) => acc + (Number(r.total) || 0), 0);
                        if (filtros.ubicacionNivel === 'ciudad') {
                          return (
                            <tr>
                              <td colSpan={2}><strong>Total</strong></td>
                              <td style={{ textAlign: 'center' }}><strong>{totalGeneral}</strong></td>
                            </tr>
                          );
                        }
                        return (
                          <tr>
                            <td><strong>Total</strong></td>
                            <td style={{ textAlign: 'center' }}><strong>{totalGeneral}</strong></td>
                          </tr>
                        );
                      })()}
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          )}
          {selectedReport === 'r21' && (
            <div className="report-content">
              <h2>Reporte de Inventario</h2>
              {loadingInventory ? (
                <div className="loading">Cargando inventario...</div>
              ) : errorInventory ? (
                <div className="error">{errorInventory}</div>
              ) : (
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Producto</th>
                        <th style={{ textAlign: 'center' }}>Cantidad</th>
                        <th>Ubicación</th>
                        <th>Categoría</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inventoryRows && inventoryRows.length > 0 ? (
                        inventoryRows.map((p) => (
                          <tr key={p.PRODUCTO_ID || p.id || p.PRODUCTO_ID}>
                            <td>{p.PRODUCTO_ID || p.id || ''}</td>
                            <td>{p.PRODUCTO_NOMBRE || p.nombre || ''}</td>
                            <td style={{ textAlign: 'center' }}>{p.PRODUCTO_CANTIDAD ?? p.cantidad ?? ''}</td>
                            <td>{(inventoryLocations.find(u => u.UBICACIONINVENTARIO_ID === p.UBICACIONINVENTARIO_ID)?.UBICACIONINVENTARIO_NOMBRE) || (inventoryLocations.find(u => u.id === p.UBICACIONINVENTARIO_ID)?.nombre) || p.UBICACIONINVENTARIO_ID || ''}</td>
                            <td>{(inventoryCategories.find(c => c.CATEGORIAINVENTARIO_ID === p.CATEGORIAINVENTARIO_ID)?.CATEGORIAINVENTARIO_NOMBRE) || (inventoryCategories.find(c => c.id === p.CATEGORIAINVENTARIO_ID)?.nombre) || p.CATEGORIAINVENTARIO_ID || ''}</td>
                          </tr>
                        ))
                      ) : (
                        <tr><td className="empty" colSpan={5}><i className="fas fa-inbox"></i> Sin datos</td></tr>
                      )}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={2}><strong>Total</strong></td>
                        <td style={{ textAlign: 'center' }}><strong>{(inventoryRows || []).reduce((acc, r) => acc + (Number(r.PRODUCTO_CANTIDAD || r.cantidad || 0) || 0), 0)}</strong></td>
                        <td colSpan={2}></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          )}
          {selectedReport === 'r1' && (
            <>
              {loading ? (
                <div className="loading">Cargando datos...</div>
              ) : error ? (
                <div className="error">Error: {error}</div>
              ) : (
                <>
                  {filtros.tipoSocio && (
                    <div className="report-header" style={{ marginBottom: '20px' }}>
                      <h2>Reporte Tipo de Socia</h2>
                      {tiposSocias.find(t => t.TS === filtros.tipoSocio) && (
                        <>
                          <p><strong>ID:</strong> {filtros.tipoSocio}</p>
                          <p><strong>Nombre:</strong> {tiposSocias.find(t => t.TS === filtros.tipoSocio).TIPOSOCIA_NOMBRE}</p>
                          <p><strong>Descripción:</strong> {tiposSocias.find(t => t.TS === filtros.tipoSocio).TIPOSOCIA_OBSERVACION}</p>
                        </>
                      )}
                    </div>
                  )}
                  <SimpleTable 
                    columns={[
                      { key: 'sociaId', header: 'ID de la Socia' },
                      { key: 'sociaCedula', header: 'Cédula de la Socia' },
                      { key: 'sociaNombre', header: 'Nombre de la Socia' },
                      { key: 'sociaApellido', header: 'Apellido de la Socia' }
                    ]} 
                    data={socias.filter(socia => !filtros.tipoSocio || socia.ts === filtros.tipoSocio)} 
                    empty="No hay socias registradas para este tipo"
                  />
                </>
              )}
            </>
          )}

          {selectedReport === 'r9' && (
            <div className="report-content">
              <h2>Incidencia de características</h2>
              {loadingCaracteristicas || loading ? (
                <div className="loading">Cargando características...</div>
              ) : errorCaracteristicas ? (
                <div className="error">{errorCaracteristicas}</div>
              ) : (
                <div className="table-container">
                  {(() => {
                    // Construir mapa inicial desde el catálogo de características
                    const map = new Map();
                    (caracteristicas || []).forEach(c => {
                      const id = String(c.id || c.CARACTERISTICA_ID || '');
                      map.set(id, { id, nombre: c.nombre || c.CARACTERISTICA_NOMBRE || '', observacion: c.observacion || c.CARACTERISTICA_OBSERVACION || '', total: 0, socias: [] });
                    });

                    // Helper: extrae ids de característica desde distintos shapes posibles
                    const extractIds = (s) => {
                      if (!s) return [];
                      // 1) campo directo 'caracteristicasPresentes' (array of ids)
                      if (Array.isArray(s.caracteristicasPresentes) && s.caracteristicasPresentes.length) return s.caracteristicasPresentes.map(x => String(x));
                      // 2) campo directo 'caracteristicas' (array of ids or objects)
                      if (Array.isArray(s.caracteristicas) && s.caracteristicas.length) return s.caracteristicas.map(x => typeof x === 'object' ? String(x.id || x.CARACTERISTICA_ID || x.ID || '') : String(x));
                      // 3) nested under datosPersonales (seeds / store format)
                      if (s.datosPersonales && Array.isArray(s.datosPersonales.caracteristicasPresentes) && s.datosPersonales.caracteristicasPresentes.length) return s.datosPersonales.caracteristicasPresentes.map(x => String(x));
                      // 4) field that is a comma-separated string
                      if (typeof s.caracteristicas === 'string' && s.caracteristicas.trim()) return s.caracteristicas.split(',').map(x => x.trim()).filter(Boolean).map(x => String(x));
                      // 5) other nested variants
                      if (Array.isArray(s.caracteristicas_presentes) && s.caracteristicas_presentes.length) return s.caracteristicas_presentes.map(x => String(x));
                      // fallback empty
                      return [];
                    };

                    // Recorrer socias y contabilizar presencia (soporta múltiples formatos)
                    (socias || []).forEach(s => {
                      const ids = extractIds(s);
                      ids.forEach(pid => {
                        const key = String(pid || '');
                        if (!map.has(key)) {
                          map.set(key, { id: key, nombre: key, observacion: '', total: 0, socias: [] });
                        }
                        const entry = map.get(key);
                        entry.total = (entry.total || 0) + 1;
                        const displayName = (s.sociaNombre || s.datosPersonales?.nombres || s.nombre || '').trim();
                        const displayLast = (s.sociaApellido || s.datosPersonales?.apellidos || s.apellidos || '').trim();
                        const ced = s.sociaCedula || s.datosPersonales?.cedula || s.cedula || '';
                        const identifier = ced ? ` (${ced})` : ` (${s.sociaId || s.id || ''})`;
                        entry.socias.push(([displayName, displayLast].filter(Boolean).join(' ') || s.sociaId || s.id || '').trim() + identifier);
                      });
                    });

                    const rows = Array.from(map.values()).sort((a,b) => (b.total||0) - (a.total||0));
                    const totalGeneral = rows.reduce((acc, r) => acc + (Number(r.total) || 0), 0) || 0;

                    if (rows.length === 0) {
                      return (<table className="data-table"><tbody><tr><td className="empty"><i className="fas fa-inbox"></i> Sin datos</td></tr></tbody></table>);
                    }

                    return (
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>Característica</th>
                            <th>Descripción</th>
                            <th style={{ textAlign: 'center' }}>Total Socias</th>
                            <th style={{ textAlign: 'right' }}>%</th>
                            <th>Socias</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((r, idx) => (
                            <tr key={r.id || idx}>
                              <td><strong>{r.nombre || r.id || '—'}</strong></td>
                              <td>{r.observacion || ''}</td>
                              <td style={{ textAlign: 'center' }}>{r.total || 0}</td>
                              <td style={{ textAlign: 'right' }}>{totalGeneral > 0 ? ((Number(r.total)||0) * 100 / totalGeneral).toFixed(2) + '%' : '0%'}</td>
                              <td>{(r.socias || []).join('; ')}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td><strong>Total</strong></td>
                            <td></td>
                            <td style={{ textAlign: 'center' }}><strong>{totalGeneral}</strong></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </table>
                    );
                  })()}
                </div>
              )}
            </div>
          )}

          {selectedReport === 'r11' && (
            <div className="report-content">
              <h2>Socias con discapacidad</h2>
              {(() => {
                // Normalizar y filtrar
                const norm = (v) => (v ?? '').toString().trim().toUpperCase();
                const inRango = (pct, rango, minStr, maxStr) => {
                  const n = Number(pct);
                  if (!Number.isFinite(n)) return false;
                  const min = Number(minStr);
                  const max = Number(maxStr);
                  if (Number.isFinite(min) || Number.isFinite(max)) {
                    if (Number.isFinite(min) && n < min) return false;
                    if (Number.isFinite(max) && n > max) return false;
                    return true;
                  }
                  if (!rango) return true;
                  const [a,b] = rango.split('-').map(Number);
                  if (!Number.isFinite(a) || !Number.isFinite(b)) return true;
                  return n >= a && n <= b;
                };
                const rowsBase = (socias||[]).map(s => {
                  const rawCarnet = s.sociaCarnetDiscapacidad;
                  // Normalizar a etiquetas claras: 'SI' para 1/true/si, 'No' para 0/false/no
                  const toLabel = (v) => {
                    if (v === 1 || v === '1' || v === true) return 'SI';
                    if (v === 0 || v === '0' || v === false) return 'No';
                    const str = (v ?? '').toString().trim();
                    if (!str) return '';
                    const up = str.toUpperCase();
                    if (['SI','S','YES','Y','TRUE','1'].includes(up)) return 'SI';
                    if (['NO','N','FALSE','0'].includes(up)) return 'No';
                    return str;
                  };

                  return {
                    id: s.sociaId,
                    nombre: `${s.sociaNombre || ''} ${s.sociaApellido || ''}`.trim(),
                    provincia: s.sociaProvincia || '',
                    ciudad: s.sociaCiudad || '',
                    carnet: toLabel(rawCarnet),
                    tipo: s.sociaTipoDiscapacidad || '',
                    porcentaje: s.sociaPorcentajeDiscapacidad,
                    grado: s.sociaGrado || ''
                  };
                });
                const rows = rowsBase.filter(r => {
                  if (filtros.discapCarnet) {
                    const want = norm(filtros.discapCarnet);
                    if (r.carnet !== want) return false;
                  }
                  if (filtros.discapTipo && norm(r.tipo) !== norm(filtros.discapTipo)) return false;
                  if (filtros.discapGrado && norm(r.grado) !== norm(filtros.discapGrado)) return false;
                  if ((filtros.discapRango || filtros.discapPctMin || filtros.discapPctMax) && !inRango(r.porcentaje, filtros.discapRango, filtros.discapPctMin, filtros.discapPctMax)) return false;
                  // por defecto mostrar sólo si tiene algún dato de discapacidad
                  const hasAny = r.carnet === 'SI' || (r.tipo && r.tipo !== '-') || Number(r.porcentaje) > 0;
                  return hasAny;
                });

                // Totales y agrupación por tipo
                const total = rows.length;
                const porTipo = new Map();
                rows.forEach(r => {
                  const key = r.tipo || 'No especificado';
                  porTipo.set(key, (porTipo.get(key) || 0) + 1);
                });
                const tiposOrdenados = Array.from(porTipo.entries()).sort((a,b) => b[1]-a[1]);

                return (
                  <>
                    <div className="table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Provincia</th>
                            <th>Cantón</th>
                            <th>Carnet</th>
                            <th>Tipo</th>
                            <th>Grado</th>
                            <th style={{ textAlign: 'center' }}>%</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.length === 0 ? (
                            <tr><td className="empty" colSpan={8}><i className="fas fa-inbox"></i> Sin datos</td></tr>
                          ) : (
                            rows.map((r, idx) => (
                              <tr key={idx}>
                                <td>{r.id}</td>
                                <td>{r.nombre}</td>
                                <td>{r.provincia}</td>
                                <td>{r.ciudad}</td>
                                <td>{r.carnet || ''}</td>
                                <td>{r.tipo || 'No especificado'}</td>
                                <td>{r.grado || ''}</td>
                                <td style={{ textAlign: 'center' }}>{Number.isFinite(Number(r.porcentaje)) ? Number(r.porcentaje) : ''}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan={7}><strong>Total</strong></td>
                            <td style={{ textAlign: 'center' }}><strong>{total}</strong></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    {/* Resumen por tipo */}
                    <div style={{ marginTop: 12 }}>
                      <h3 style={{ margin: '8px 0' }}>Resumen por tipo</h3>
                      <div className="table-container">
                        <table className="data-table">
                          <thead>
                            <tr>
                              <th>Tipo</th>
                              <th style={{ textAlign: 'center' }}>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {tiposOrdenados.length === 0 ? (
                              <tr><td className="empty" colSpan={2}><i className="fas fa-inbox"></i> Sin datos</td></tr>
                            ) : (
                              tiposOrdenados.map(([t, c]) => (
                                <tr key={t}>
                                  <td>{t}</td>
                                  <td style={{ textAlign: 'center' }}>{c}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>
          )}

          {selectedReport === 'r12' && (
            <div className="report-content">
              <h2>Socias afiliadas al IESS</h2>
              {loadingR12 ? (
                <div className="empty"><i className="fas fa-spinner fa-spin"></i> Cargando...</div>
              ) : errorR12 ? (
                <div className="error">{errorR12}</div>
              ) : (() => {
                const rows = (r12Rows || []).map(s => ({
                  id: s.sociaId,
                  nombre: `${s.sociaNombre || ''} ${s.sociaApellido || ''}`.trim(),
                  cedula: s.sociaCedula || '',
                  iees: s.sociaIees || ''
                }));

                const total = rows.length;
                const afiliados = rows.filter(r => r.iees && typeof r.iees === 'string' && r.iees.toUpperCase() === 'SI').length;
                const noAfiliados = rows.filter(r => r.iees && typeof r.iees === 'string' && r.iees.toUpperCase() === 'NO').length;

                return (
                  <>
                    <div style={{ marginBottom: '20px', display: 'flex', gap: '20px', justifyContent: 'center' }}>
                      <div><strong>Total:</strong> {total}</div>
                      <div><strong>Afiliados:</strong> {afiliados}</div>
                      <div><strong>No Afiliados:</strong> {noAfiliados}</div>
                    </div>

                    <div className="table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Cédula</th>
                            <th>Afiliado IESS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.length === 0 ? (
                            <tr><td className="empty" colSpan={4}><i className="fas fa-inbox"></i> Sin datos</td></tr>
                          ) : (
                            rows.map((r, idx) => (
                              <tr key={idx}>
                                <td>{r.id}</td>
                                <td>{r.nombre}</td>
                                <td>{r.cedula}</td>
                                <td>{r.iees}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                );
              })()}
            </div>
          )}

          {selectedReport === 'r13' && (
            <div className="report-content">
              <h2>Gráfico de Talla por Socia</h2>

              {!filtros.sociaId ? (
                <div className="empty" style={{ marginTop: 20 }}>
                  <i className="fas fa-info-circle"></i> Seleccione una socia para ver su historial de tallas.
                </div>
              ) : loadingR13 ? (
                <div className="loading">Cargando datos...</div>
              ) : errorR13 ? (
                <div className="error">{errorR13}</div>
              ) : (() => {
                const rows = (r13Rows || []).map(r => ({
                  fecha: r.fechaRegistro,
                  talla: parseFloat(r.tallaCm) || 0,
                  nombre: `${r.sociaNombre || ''} ${r.sociaApellido || ''}`.trim()
                }));

                if (rows.length === 0) {
                  return (
                    <div className="empty" style={{ marginTop: 20 }}>
                      <i className="fas fa-inbox"></i> No hay registros de talla para esta socia en el rango seleccionado.
                    </div>
                  );
                }

                const sociaName = rows[0]?.nombre || '';
                const minTalla = Math.min(...rows.map(r => r.talla));
                const maxTalla = Math.max(...rows.map(r => r.talla));
                const avgTalla = (rows.reduce((sum, r) => sum + r.talla, 0) / rows.length).toFixed(2);

                return (
                  <>
                    <div style={{ marginBottom: '20px', padding: '15px', background: 'var(--card-bg)', borderRadius: '8px' }}>
                      <h3 style={{ marginTop: 0 }}>{sociaName}</h3>
                      <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap' }}>
                        <div><strong>Total Registros:</strong> {rows.length}</div>
                        <div><strong>Talla Mínima:</strong> {minTalla} cm</div>
                        <div><strong>Talla Máxima:</strong> {maxTalla} cm</div>
                        <div><strong>Talla Promedio:</strong> {avgTalla} cm</div>
                      </div>
                    </div>

                    {/* Gráfico de línea temporal */}
                    <div id="chart-r13-talla" style={{ marginTop: '30px', padding: '20px', background: 'var(--card-bg)', borderRadius: '8px' }}>
                      <h3>Evolución de Talla</h3>
                      <div style={{ height: '400px', position: 'relative' }}>
                        <Line
                          data={{
                            labels: rows.map(r => new Date(r.fecha).toLocaleDateString('es-ES')),
                            datasets: [
                              {
                                label: 'Talla (cm)',
                                data: rows.map(r => r.talla),
                                borderColor: 'rgb(75, 192, 192)',
                                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                                tension: 0.1,
                                pointRadius: 5,
                                pointHoverRadius: 7
                              }
                            ]
                          }}
                          options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                              legend: {
                                display: true,
                                position: 'top'
                              },
                              title: {
                                display: false
                              },
                              tooltip: {
                                callbacks: {
                                  label: function(context) {
                                    return `Talla: ${context.parsed.y} cm`;
                                  }
                                }
                              }
                            },
                            scales: {
                              y: {
                                beginAtZero: false,
                                title: {
                                  display: true,
                                  text: 'Talla (cm)'
                                }
                              },
                              x: {
                                title: {
                                  display: true,
                                  text: 'Fecha de Registro'
                                }
                              }
                            }
                          }}
                        />
                      </div>
                    </div>

                    {/* Tabla de datos */}
                    <div className="table-container" style={{ marginTop: '30px' }}>
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>Fecha de Registro</th>
                            <th>Talla (cm)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((r, idx) => (
                            <tr key={idx}>
                              <td>{new Date(r.fecha).toLocaleDateString('es-ES')}</td>
                              <td>{r.talla}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                );
              })()}
            </div>
          )}

          {selectedReport === 'r16' && (
            <div className="report-content">
              <h2>Documentos entregados por socia</h2>
              {selectedSocia && (
                <div style={{ marginTop: -4, marginBottom: 12 }}>
                  <strong>Socia:</strong> {selectedSocia.sociaNombre} {selectedSocia.sociaApellido} <span style={{ color: 'var(--text-muted)' }}>({selectedSocia.sociaId})</span>
                </div>
              )}

              {!filtros.sociaId ? (
                <div className="empty" style={{ marginTop: 12 }}>
                  <i className="fas fa-info-circle"></i> Seleccione una socia para ver sus documentos entregados y pendientes.
                </div>
              ) : loadingReq ? (
                <div className="loading">Cargando requisitos...</div>
              ) : errorReq ? (
                <div className="error">{errorReq}</div>
              ) : (
                <>
                  {/* Cálculo de pendientes */}
                  {(() => {
                    const nombresCatalogo = reqCatalogo.map(r => r.nombre);
                    const setEntregados = new Set(reqEntregados);
                    const pendientes = nombresCatalogo.filter(n => !setEntregados.has(n));
                    return (
                      <div className="table-container">
                        <table className="data-table">
                          <thead>
                            <tr>
                              <th>Documento</th>
                              <th>Estado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {nombresCatalogo.length === 0 ? (
                              <tr>
                                <td className="empty" colSpan={2}><i className="fas fa-inbox"></i> Catálogo de requisitos vacío</td>
                              </tr>
                            ) : (
                              <>
                                {/* Entregados */}
                                {reqEntregados.map((n, idx) => (
                                  <tr key={`ent-${idx}`}>
                                    <td>{n}</td>
                                    <td><span className="status-badge activo">Entregado</span></td>
                                  </tr>
                                ))}
                                {/* Pendientes */}
                                {pendientes.map((n, idx) => (
                                  <tr key={`pen-${idx}`}>
                                    <td>{n}</td>
                                    <td><span className="status-badge inactivo">Pendiente</span></td>
                                  </tr>
                                ))}
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    );
                  })()}
                </>
              )}
            </div>
          )}

          {selectedReport !== 'r15' && null}

          {selectedReport === 'r2' && (
            <div className="report-content">
              <h2>Direcciones y Teléfonos de Socias</h2>  
              <SimpleTable
                
                
              columns={[
                  { key: 'id', header: 'ID' },
                  { key: 'nombre', header: 'Nombre/Apellido', render: (_, r) => r.nombre },     
                  { key: 'pais', header: 'País' },
                  { key: 'provincia', header: 'Provincia'},
                  { key: 'canton', header: 'Cantón' },
                  { key: 'direccion', header: 'Dirección' },  
                  { key: 'telefonos', header: 'Teléfonos' },
                  { key: 'correo', header: 'Email' }
                ]}
                // sin filtro para que muestre todas las socias
                data={socias.map(s => ({
                  id: s.sociaId,
                  nombre: `${s.sociaNombre} ${s.sociaApellido}`,  
                  pais: s.sociaPais,
                  provincia: s.sociaProvincia,
                  canton: s.sociaCiudad,
                  direccion: s.sociaDireccion,
                  telefonos: s.sociaTelefono1 + (s.sociaTelefono2 ? `, ${s.sociaTelefono2}` : ''),
                  correo: s.sociaEmail
                }))}
                empty="No hay datos de ubicación disponibles"
              />
              
            </div>

          )}
          
          {selectedReport === 'r3' && (
  <div className="report-content">
    <h2>Socias con el tipo de Síndrome: {filtros.tipoSindrome || 'Todos'}</h2>
    <SimpleTable
      columns={[
        { key: 'sociaId', header: 'ID' },
        {
          key: 'nombre',
          header: 'Nombre y Apellido',
          render: (_, r) => `${r.sociaNombre} ${r.sociaApellido}`
        },
        { key: 'tipoSindrome', header: 'Tipo de Síndrome' } // opcional para mostrar
      ]}
      data={socias
        .filter(s => !filtros.tipoSindrome || s.tipoSindrome === filtros.tipoSindrome)
        .map(s => ({
          ...s,
          nombre: `${s.sociaNombre} ${s.sociaApellido}`
        }))
      }
      empty="No hay socias para el tipo de síndrome seleccionado"
    />
  </div>
)}


          {selectedReport === 'r4' && (
            <div className="report-content">
              <h2>Socias por Estado</h2>
              <SimpleTable
                columns={[
                  { key: 'sociaId', header: 'ID' },
                  { key: 'nombre', header: 'Nombre y Apellido', render: (_, r) => `${r.sociaNombre} ${r.sociaApellido}` }
                ]}
                data={socias.filter(s => !filtros.estado || s.sociaEstado === filtros.estado).map(s => ({ ...s, nombre: `${s.sociaNombre} ${s.sociaApellido}` }))}
                empty="No hay socias para el estado seleccionado"
              />
            </div>
          )}

          {selectedReport === 'r5' && (
            <div className="report-content">
              <h2>SOCIAS que cumplen en {['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'][parseInt(filtros.mes,10)-1]}</h2>
              <SimpleTable
                columns={[
                  { key: 'sociaId', header: 'ID de la Socia' },
                  { key: 'nombre', header: 'Nombre y Apellido', render: (_, r) => `${r.sociaNombre} ${r.sociaApellido}` },
                  { key: 'sociaFechaNacimiento', header: 'Fecha de Nacimiento' },
                  { key: 'edad', header: 'Años que cumplirá', render: (_, r) => computeAgeTurning(r.sociaFechaNacimiento) }
                ]}
                data={sociosByBirthMonth.map(s => ({ ...s }))}
                empty="No hay socias con cumpleaños en este mes"
              />
            </div>
          )}

          {selectedReport === 'r6' && (
            <div className="report-content">
              <h2>Socias registradas de {filtros.pais || 'Todos los países'}</h2>
              <SimpleTable
                columns={[
                  { key: 'sociaId', header: 'ID' },
                  { key: 'nombre', header: 'Nombre y Apellido', render: (_, r) => `${r.sociaNombre} ${r.sociaApellido}` },
                  { key: 'sociaNacionalidad', header: 'Nacionalidad' }
                ]}
                data={socias.filter(s => !filtros.pais || s.sociaPais === filtros.pais).map(s => ({ ...s }))}
                empty="No hay socias para el país seleccionado"
              />
            </div>
          )}

          {selectedReport === 'r17' && (
            <div className="report-content">
              <h2>Socias registradas en el MSP</h2>
              <SimpleTable
                columns={[
                  { key: 'sociaId', header: 'ID' },
                  { key: 'nombre', header: 'Nombre y Apellido', render: (_, r) => `${r.sociaNombre} ${r.sociaApellido}` },
                  { key: 'sociaCedula', header: 'Cédula' },
                  { key: 'sociaEstado', header: 'Estado' },
                  { key: 'msp', header: 'Registrada MSP', render: (v) => (v ? 'Sí' : 'No') },
                ]}
                data={socias
                  .filter(s => (filtros.msp === '' ? true : String(s.sociaMsp) === filtros.msp))
                  .map(s => ({ ...s, msp: Number(s.sociaMsp) === 1 }))}
                empty="No hay socias para el filtro seleccionado"
              />
            </div>
          )}
          {selectedReport === 'r20' && (
            <div className="report-content">
              <h2>Gráfico de socias por Síndrome y Ubicación</h2>
              <p style={{ marginTop: -8, color: 'var(--text-muted)' }}>
                Visualiza la distribución por país y, si eliges un país, la distribución de síndromes dentro de ese país.
              </p>
              {(() => {
                // Conteo por país filtrando por tipo de síndrome (opcional)
                const mapPais = new Map();
                (socias || []).forEach(s => {
                  const pais = s?.sociaPais || 'No especificado';
                  const ts = s?.sociaTipoSindrome || '';
                  if (filtros.tipoSindrome && ts !== filtros.tipoSindrome) return;
                  mapPais.set(pais, (mapPais.get(pais) || 0) + 1);
                });
                const rowsPais = Array.from(mapPais.entries()).map(([label, value]) => ({ label, value }));
                rowsPais.sort((a,b) => b.value - a.value);
                const maxPais = rowsPais.reduce((m, r) => Math.max(m, r.value), 0) || 1;
                return (
                  <div style={{ marginBottom: 16 }} id="chart-r20-por-pais">
                    <HBarChart
                      title={`Socias ${filtros.tipoSindrome ? `con "${filtros.tipoSindrome}"` : ''} por país`}
                      data={rowsPais}
                      maxValue={maxPais}
                      barColor="#8e44ad"
                    />
                    <div className="table-container" style={{ marginTop: 12 }}>
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>País</th>
                            <th style={{ textAlign: 'right' }}>Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rowsPais.length === 0 ? (
                            <tr><td className="empty" colSpan={2}><i className="fas fa-inbox"></i> Sin datos</td></tr>
                          ) : rowsPais.map((r, idx) => (
                            <tr key={idx}>
                              <td>{r.label}</td>
                              <td style={{ textAlign: 'right' }}>{r.value}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })()}

              {filtros.pais && (() => {
                // Dentro del país seleccionado: conteo por síndrome
                const mapTs = new Map();
                (socias || []).forEach(s => {
                  if ((s?.sociaPais || '') !== filtros.pais) return;
                  const ts = s?.sociaTipoSindrome || 'No especificado';
                  mapTs.set(ts, (mapTs.get(ts) || 0) + 1);
                });
                const rowsTs = Array.from(mapTs.entries()).map(([label, value]) => ({ label, value }));
                rowsTs.sort((a,b) => b.value - a.value);
                const maxTs = rowsTs.reduce((m, r) => Math.max(m, r.value), 0) || 1;
                return (
                  <div id="chart-r20-por-sindrome">
                    <HBarChart
                      title={`Distribución de síndromes en ${filtros.pais}`}
                      data={rowsTs}
                      maxValue={maxTs}
                      barColor="#27ae60"
                    />
                    <div className="table-container" style={{ marginTop: 12 }}>
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>Tipo de Síndrome</th>
                            <th style={{ textAlign: 'right' }}>Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rowsTs.length === 0 ? (
                            <tr><td className="empty" colSpan={2}><i className="fas fa-inbox"></i> Sin datos</td></tr>
                          ) : rowsTs.map((r, idx) => (
                            <tr key={idx}>
                              <td>{r.label}</td>
                              <td style={{ textAlign: 'right' }}>{r.value}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}

          {selectedReport === 'r14' && (
            <div className="report-content">
              <h2>Edad de Detección por País</h2>
              <p style={{ marginTop: -8, color: 'var(--text-muted)', marginBottom: 20 }}>
                Estadísticas de edad de detección agrupadas por país. Los datos se obtienen de la base de datos y muestran promedios, medianas y rangos.
              </p>

              {loadingR14 && (
                <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-muted)' }}>
                  <i className="fas fa-spinner fa-spin" style={{ fontSize: '2rem', marginBottom: 12 }}></i>
                  <p>Cargando datos de edad de detección...</p>
                </div>
              )}

              {errorR14 && (
                <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--error-color)', background: 'rgba(255,0,0,0.05)', borderRadius: 8, border: '1px solid rgba(255,0,0,0.2)' }}>
                  <i className="fas fa-exclamation-triangle" style={{ fontSize: '1.5rem', marginBottom: 8 }}></i>
                  <p><strong>Error:</strong> {errorR14}</p>
                </div>
              )}

              {!loadingR14 && !errorR14 && edadDeteccionByCountry.rows.length === 0 && (
                <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-muted)' }}>
                  <i className="fas fa-inbox" style={{ fontSize: '3rem', marginBottom: 12, opacity: 0.3 }}></i>
                  <p>No hay datos de edad de detección disponibles</p>
                </div>
              )}

              {!loadingR14 && !errorR14 && edadDeteccionByCountry.rows.length > 0 && (
                <>
                  {/* Tabla de estadísticas detalladas */}
                  <div style={{ marginBottom: 16 }}>
                    <h3 style={{ fontSize: '1.1rem', marginBottom: 16, color: 'var(--primary-color)' }}>
                      <i className="fas fa-table" style={{ marginRight: 8 }}></i>
                      Estadísticas Detalladas por País
                    </h3>
                  </div>

                  <div className="table-container">
                    <table className="data-table">
                      <thead>
                        <tr>
                          <th>País</th>
                          <th style={{ textAlign: 'right' }}>Cantidad</th>
                          <th style={{ textAlign: 'right' }}>Edad Promedio</th>
                          <th style={{ textAlign: 'right' }}>Mín</th>
                          <th style={{ textAlign: 'right' }}>Mediana</th>
                          <th style={{ textAlign: 'right' }}>Máx</th>
                          <th>Distribución</th>
                        </tr>
                      </thead>
                      <tbody>
                        {edadDeteccionByCountry.rows.map((r, idx) => (
                          <tr key={idx}>
                            <td><strong>{r.pais}</strong></td>
                            <td style={{ textAlign: 'right' }}>
                              <span style={{ background: 'var(--surface-hover)', padding: '4px 12px', borderRadius: 12, fontSize: '0.9rem' }}>
                                {r.count} {r.count === 1 ? 'caso' : 'casos'}
                              </span>
                            </td>
                            <td style={{ textAlign: 'right' }}>
                              <strong style={{ color: 'var(--primary-color)' }}>{r.avg} años</strong>
                            </td>
                            <td style={{ textAlign: 'right', color: 'var(--success-color)' }}>{r.min}</td>
                            <td style={{ textAlign: 'right', color: 'var(--text-color)' }}><strong>{r.median}</strong></td>
                            <td style={{ textAlign: 'right', color: 'var(--warning-color)' }}>{r.max}</td>
                            <td>
                              <div style={{ background: 'var(--surface-hover)', borderRadius: 6, padding: 4, position: 'relative' }}>
                                <div
                                  style={{
                                    height: 14,
                                    width: `${Math.max(10, (r.avg / edadDeteccionByCountry.maxAvg) * 100)}%`,
                                    background: `linear-gradient(90deg, var(--primary-color), #66bb6a)`,
                                    borderRadius: 4,
                                    transition: 'width .3s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    paddingRight: 6
                                  }}
                                  title={`Promedio: ${r.avg} años`}
                                >
                                  <span style={{ fontSize: '0.7rem', color: 'white', fontWeight: 'bold', textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}>
                                    {r.avg}
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Resumen estadístico */}
                  <div style={{ marginTop: 24, marginBottom: 32, padding: 16, background: 'var(--surface-hover)', borderRadius: 8, display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                    <div>
                      <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Total de casos:</span>
                      <strong style={{ marginLeft: 8, fontSize: '1.1rem', color: 'var(--primary-color)' }}>
                        {edadDeteccionByCountry.rows.reduce((sum, r) => sum + r.count, 0)}
                      </strong>
                    </div>
                    <div>
                      <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Países registrados:</span>
                      <strong style={{ marginLeft: 8, fontSize: '1.1rem', color: 'var(--primary-color)' }}>
                        {edadDeteccionByCountry.rows.length}
                      </strong>
                    </div>
                    <div>
                      <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Promedio global:</span>
                      <strong style={{ marginLeft: 8, fontSize: '1.1rem', color: 'var(--primary-color)' }}>
                        {(edadDeteccionByCountry.rows.reduce((sum, r) => sum + (r.avg * r.count), 0) / 
                          edadDeteccionByCountry.rows.reduce((sum, r) => sum + r.count, 0)).toFixed(2)} años
                      </strong>
                    </div>
                  </div>

                  {/* Gráfico 1: Promedio de edad por país */}
                  <div style={{ marginBottom: 32 }} id="chart-edad-pais">
                    <h3 style={{ fontSize: '1.1rem', marginBottom: 16, color: 'var(--primary-color)' }}>
                      <i className="fas fa-chart-bar" style={{ marginRight: 8 }}></i>
                      Promedio de Edad de Detección por País
                    </h3>
                    <VBarChart
                      title=""
                      data={edadDeteccionByCountry.rows.map(r => ({ label: r.pais, value: r.avg }))}
                      maxValue={Math.ceil(edadDeteccionByCountry.maxAvg)}
                    />
                  </div>

                  {/* Gráfico 2: Distribución por rangos (global) */}
                  <div style={{ marginBottom: 32 }} id="chart-rangos-global">
                    <h3 style={{ fontSize: '1.1rem', marginBottom: 16, color: 'var(--primary-color)' }}>
                      <i className="fas fa-chart-bar" style={{ marginRight: 8 }}></i>
                      Distribución por Rangos de Edad (Global)
                    </h3>
                    <HBarChart
                      title=""
                      data={edadDeteccionRangos.counts}
                      maxValue={edadDeteccionRangos.max}
                      barColor="#42a5f5"
                    />
                  </div>
                </>
              )}
            </div>
          )}
          {selectedReport === 'r18' && (
            <div className="report-content">
              <h2>Mentoras</h2>
              <SimpleTable
                columns={[
                  { key: 'mentorId', header: 'ID' },
                  { key: 'mentorNombre', header: 'Nombre' },
                  { key: 'mentorSector', header: 'Sector' },
                  { key: 'mentorEstado', header: 'Estado' },
                  { key: 'asignadas', header: 'Socias Asignadas' },
                ]}
                data={mentores.map((m) => ({
                  ...m,
                  asignadas: socias.filter((s) => String(s.mentorId || '') === String(m.mentorId)).length,
                }))}
                empty="No hay mentoras registradas"
              />
            </div>
          )}

          {selectedReport === 'r19' && (
            <div className="report-content">
              <h2>Socias agrupadas por mentora</h2>
              {filtros.mentorId === '' ? (
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Mentora</th>
                        <th>Cantidad Socias</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mentores.length === 0 ? (
                        <tr><td className="empty" colSpan={2}><i className="fas fa-inbox"></i> Sin mentoras</td></tr>
                      ) : (
                        mentores.map((m) => {
                          const count = socias.filter((s) => String(s.mentorId || '') === String(m.mentorId)).length;
                          return (
                            <tr key={m.mentorId}>
                              <td>{m.mentorNombre}{m.mentorSector ? ` — ${m.mentorSector}` : ''}</td>
                              <td>{count}</td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                <SimpleTable
                  columns={[
                    { key: 'sociaId', header: 'ID' },
                    { key: 'nombre', header: 'Nombre y Apellido', render: (_, r) => `${r.sociaNombre} ${r.sociaApellido}` },
                    { key: 'sociaCedula', header: 'Cédula' },
                    { key: 'sociaEstado', header: 'Estado' },
                  ]}
                  data={socias.filter((s) => String(s.mentorId || '') === String(filtros.mentorId))}
                  empty="No hay socias para la mentora seleccionada"
                />
              )}
            </div>
          )}
          {selectedReport === 'r15' && (
            <div className="report-content">
              <h2>Medicamentos y Tratamientos por Socia</h2>
              {selectedSocia && (
                <div style={{ marginTop: -4, marginBottom: 12 }}>
                  <strong>Socia:</strong> {selectedSocia.sociaNombre} {selectedSocia.sociaApellido} <span style={{ color: 'var(--text-muted)' }}>({selectedSocia.sociaId})</span>
                </div>
              )}
              {!filtros.sociaId ? (
                <div className="empty" style={{ marginTop: 12 }}>
                  <i className="fas fa-info-circle"></i> Seleccione una socia para ver sus tratamientos.
                </div>
              ) : loadingTratamientos ? (
                <div className="loading">Cargando tratamientos...</div>
              ) : errorTratamientos ? (
                <div className="error">{errorTratamientos}</div>
              ) : tratamientosSocia.length === 0 ? (
                <div className="empty"><i className="fas fa-inbox"></i> La socia no tiene tratamientos registrados.</div>
              ) : (
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Tratamiento</th>
                        <th>Médico</th>
                        <th>Especialidad</th>
                        <th>Fecha Inicio</th>
                        <th>Fecha Fin</th>
                        <th>Observación</th>
                        <th>Medicamentos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tratamientosSocia.map((t) => (
                        <tr key={t.TRATAMIENTO_ID}>
                          <td>{t.TRATAMIENTO_ID}</td>
                          <td>{[t.MEDICO_NOMBRE, t.MEDICO_APELLIDO].filter(Boolean).join(' ') || '—'}</td>
                          <td>{t.MEDICO_ESPECIALIDAD || '—'}</td>
                          <td>{t.TRATAMIENTO_FECHAINICIO ? new Date(t.TRATAMIENTO_FECHAINICIO).toLocaleDateString() : '—'}</td>
                          <td>{t.TRATAMIENTO_FECHAFIN ? new Date(t.TRATAMIENTO_FECHAFIN).toLocaleDateString() : '—'}</td>
                          <td>{t.TRATAMIENTO_OBSERVACION || '—'}</td>
                          <td>
                            {Array.isArray(t.MEDICAMENTOS) && t.MEDICAMENTOS.length > 0 ? (
                              <ul style={{ paddingLeft: 18, margin: 0 }}>
                                {t.MEDICAMENTOS.map((m) => (
                                  <li key={m.MEDICAMENTO_ID}>
                                    {m.MEDICAMENTO_NOMBRE} — {m.MEDICAMENTO_CANTIDAD}{m.MEDICAMENTO_UNIDAD ? ` ${m.MEDICAMENTO_UNIDAD}` : ''}
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <span className="text-muted">Sin medicamentos</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
          <FooterReport />
        </div>
      </main>
    </div>
  );
}

export default Reports;
